// @flow
import * as React from "react"
import Button from "components/Button"
import Checkbox from "components/Checkbox"
import { Title } from "componentsStyled/Typography/Titles"
import { Text } from "componentsStyled/Typography/Texts"
import { PageTitle } from "componentsStyled/Typography/Titles"
import type { Plan } from "data/plans/types"
import ModalBody from "modals/_Body"
import ModalContent from "modals/_Content"
import ModalControls from "modals/_Controls"
import { Content, StyledWrap as Wrap } from "./styled"

type Props = {|
  close: Function,
  plan: Plan,
  currentStep?: string,
  finalStep?: string,
  fromCheckout?: boolean,
|}

const SubscribePlanConfirmation = ({ close, plan, currentStep, finalStep, fromCheckout }: Props) => (
  <ModalBody close={close}>
    <ModalContent>
      <Content>
        <Wrap stack bottom>
          <Title center>{plan.title}</Title>
          <Text center>{plan.subtitle}</Text>
        </Wrap>
        <Wrap stack bottom>
          <Checkbox value={true} big />
          <br/>
          <PageTitle>Congrats!</PageTitle>
        </Wrap>
        <Wrap stack bottom>
          <Text center black bold>You're all set.</Text>
          <Text center black>{plan.confirmationText}</Text>
        </Wrap>
      </Content>
    </ModalContent>
    <ModalControls column>
      {currentStep && finalStep
        ? <Text black center>
          Step <Text inline black bold>{currentStep}</Text> of {finalStep}
        </Text>
        : ""}
      <Button fullwidth onClick={() => close()}>
        {fromCheckout ? "Proceed to checkout" : "Continue shopping"}
      </Button>
    </ModalControls>
  </ModalBody>
)

export default SubscribePlanConfirmation



// WEBPACK FOOTER //
// ./src/modals/SubscribePlanConfirmation/index.js